document.addEventListener("DOMContentLoaded", () => {
    const navLinks = document.querySelectorAll(".nav-letter");
    const sections = document.querySelectorAll(".vendor-section");

    let disableScrollHandler = false;

    navLinks.forEach(link => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("href").substring(1);
        const target = document.getElementById(targetId);

        if (target) {
          disableScrollHandler = true;

          target.scrollIntoView({ behavior: "smooth", block: "start" });

          navLinks.forEach(l => l.classList.remove("active"));
          link.classList.add("active");


          setTimeout(() => {
            disableScrollHandler = false;
          }, 1000);
        }
      });
    });

    function updateActiveNav() {
      if (disableScrollHandler) return;

      let activeId = null;

      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 120 && rect.bottom > 120) {
          activeId = section.id.replace("vendor-", "");
        }
      });

      if (activeId) {
        navLinks.forEach(link => {
            link.classList.toggle("active", link.dataset.letter === activeId);
        });
        }
    }

    window.addEventListener("scroll", updateActiveNav);

    const firstActiveLink = Array.from(navLinks).find(link => !link.classList.contains("nav-letter--disabled"));
    if (firstActiveLink) {
      firstActiveLink.classList.add("active");
    }
});